<template>
  <div class="divPRow">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export class PRow extends Vue {}
export default PRow;
</script>
<style scoped>
.divPRow {
  display: flex;
  flex-wrap: wrap;
}
</style>
